"use strict";
import "./_bootstrap";
import "./_add-to-cart";
import "./front-vue";

var FAILED_IMAGE_URL = 'https://share.gambody.com/static/image/ge-failed-image.png';

App.init = function() {
    var ths = this;
    for (var i=0; i<this.modules.length; i++) {
        new window[this.modules[i].name](this.modules[i].options);
    }

    this.initLoveButtons();
    this.initRatingButtons();
    this.initMisc();
    this.initNavigation();
    this.initProductAnalytics();

    this.maybeInitPreviews();
    this.initSearchAutocomplete();
    this.initCart();
}

App.initCart = function() {
    $("#cart-container").on("mouseenter", function() {
        App.callbacks.cartHovered && App.callbacks.cartHovered.call(window, JSON.parse(this.dataset.cart));
    });
};

App.initSearchAutocomplete = function() {
    let stockMode = $("#search-input").data("stock");
    $("#search-input").autocomplete({
        source: "/api/autocomplete-search" + (stockMode ? "?stock=1" : ""),
        minlength: 2,
        select(event, ui) {
            event.target.value = "exact: " + ui.item.value;
            $(event.target).parents("form").submit();
            event.preventDefault();
        }
    })
}

App.initLoveButtons = function() {
    $('.likeButton.enabled, .presentButton.enabled').click(function(){
        var $this = this;

        if (!$($this).hasClass('active'))
            $($this).addClass('active');
        else
            $($this).removeClass('active');

        $.ajax({
            url: $(this).data('href'),
            dataType: 'json',
            method: "post",
            success: function(result){
                if ($('span.txt',$this).length > 0)
                    $('span.txt',$this).text(result.count);

                if (result.active && !$($this).hasClass('active'))
                    $($this).addClass('active');
                if (!result.active && $($this).hasClass('active'))
                    $($this).removeClass('active');

                if (result.active) {
                    let listenerKey;
                    if ($($this).data('href').includes("wish")) {
                        listenerKey = "addedToWishlist";
                    } else {
                        listenerKey = "addedToFavorites";
                    }

                    try {
                        // admin defined callbacks for add-to-cart event
                        App.callbacks[listenerKey] && App.callbacks[listenerKey].call(
                            null,
                            result.object,
                            $($this).parents(".tile").data("item-list")
                        );
                    } catch (e) {

                    }
                }
            },
            error: function() {
                alert("Server error");
                if (!$($this).hasClass('active'))
                    $($this).addClass('active');
                else
                    $($this).removeClass('active');
            }
        });
        return false;
    });
}

App.initRatingButtons = function() {
    $('div.rating a').mouseenter(function(){
        App.fillRating($(this).data('vote'), $(this).parent());
    });
    $('div.rating').mouseleave(function(){
        App.fillRating(null, $(this));
    });

    $('div.rating a.star').click(function(){
        var container = $(this).parent();

        axios.post(this.dataset.href, {vote: this.dataset.vote}).then(function(resp) {
            $('.fnc-count', container).text(resp.data.count);
            container.data('score', resp.data.score);
            App.fillRating(resp.data.score, container);
        }).catch(function(error) {
            if (error.response && error.response.status==401) {
                alertify.error("Please log in to vote.", 10000);
            } else {
                alertify.error(error.message, 10000);
            }
        })

        return false;
    });
}

App.initMisc = function() {
    var fillSizeSelector = function() {
        $('.sizeControl .control .bg').css('left', $('.sizeControl .control .sizeFrom').css('left'));
        $('.sizeControl .control .bg').css('width', parseInt($('.sizeControl .control .sizeTo').css('left'))-parseInt($('.sizeControl .control .sizeFrom').css('left')));
    }
    var applySizeTimer = null;
    var applySizeSelector = function(timeout) {
        timeout = timeout || 1500;
        if (applySizeTimer) {
            clearTimeout(applySizeTimer);
        }
        applySizeTimer = setInterval(function(){
            var url = $('.sizeControl').attr('url-pattern');
            url = url.replace('%21size-from%21',sizeSelectorFrom);
            url = url.replace('%21size-to%21',sizeSelectorTo);

            location.href = url;
        },timeout);
    }
    var moveSizeSelectors = function( ui ) {
        if ($(ui.helper).hasClass('sizeFrom') &&
            ui.position.left > parseInt($('.sizeControl .control .sizeTo').css('left')))
        {
            ui.position.left = parseInt($('.sizeControl .control .sizeTo').css('left'));
            $(ui.helper).css('left',parseInt($('.sizeControl .control .sizeTo').css('left'))+'px');
        }
        if ($(ui.helper).hasClass('sizeTo') &&
            ui.position.left < parseInt($('.sizeControl .control .sizeFrom').css('left')))
        {
            ui.position.left = parseInt($('.sizeControl .control .sizeFrom').css('left'));
            $(ui.helper).css('left',parseInt($('.sizeControl .control .sizeFrom').css('left'))+'px');
        }

        var steps = {
            'tiny' : 25,
            'small': 70,
            'average': 120,
            'big': 165,
            'huge': 215
        };
        var goTo = null;
        var minDiff = null;
        for (var i in steps)
        {
            if (minDiff === null || Math.abs(ui.position.left-steps[i]) < minDiff)
            {
                minDiff = Math.abs(ui.position.left-steps[i]);
                goTo = i;
            }
        }
        $(ui.helper).css('left',steps[goTo]+'px');

        if ($(ui.helper).hasClass('sizeFrom'))
        {
            $('.sizeControl .txtFrom').text(goTo);
            sizeSelectorFrom = goTo;
        }
        if ($(ui.helper).hasClass('sizeTo'))
        {
            $('.sizeControl .txtTo').text(goTo);
            sizeSelectorTo = goTo;
        }

        fillSizeSelector();
    }

    var moveSizeSelectorIndex = 0;
    $('.sizeControl .control').click(function(e){
        var parentOffset = $(this).offset();
        var relX = e.pageX - parentOffset.left;

        var ui = {};

        if (moveSizeSelectorIndex == 0)
        {
            var el = $('.sizeControl .control .sizeFrom');
        }
        else
        {
            var el = $('.sizeControl .control .sizeTo');
        }
        el.css('left',parseInt(relX)+'px');
        ui.helper = el;
        ui.position = {
            left: parseInt($(ui.helper).css('left'))
        };
        moveSizeSelectors(ui);

        if (moveSizeSelectorIndex >= 1)
            moveSizeSelectorIndex = 0;
        else
            moveSizeSelectorIndex++;

        applySizeSelector(2500);
    });

    $('.sizeControl .control .bul').draggable({
        axis: "x",
        containment: "parent",
        start: function( event, ui ) {
            if (applySizeTimer)
            {
                clearTimeout(applySizeTimer);
            }
        },
        drag: function( event, ui ) {
            fillSizeSelector();
        },
        stop: function (event, ui)
        {
            moveSizeSelectors(ui);
            applySizeSelector();
        }
    });

    // dropdown menus
    $(document).on("click", ".dropdown [data-toggle]", function(e) {
        e.preventDefault();
        if ($(this).closest('.dropdown').attr('disabled')) return false;
        $(this).parent().toggleClass("open");
    });

    $(document).on("click", function(e) {
        if ($(e.target).closest(".dropdown").length == 0) {
            $(".dropdown").removeClass("open");
        }
    });

    // handle tabs
    $(".tabs .tab").on("click", function(e) {
        $(".tabs .tab").removeClass("active");
        $(e.target).addClass("active");
        $(".tab-content").hide();
        $("#" + $(e.target).data("target")).show();
    });
}

/**
 * Has to do with model star ratings
 */
App.fillRating = function(score, ratingEl){
    if (!score) {
        score = ratingEl.data("score");
    }

    $('a.star', ratingEl).removeClass(["star-full", "star-half"]);

    $('a.star', ratingEl).each(function(idx, el){
        if (score >= idx+1)
            $(el).addClass('star-full');
        else if (score < idx+1 && score >= idx+0.5)
            $(el).addClass('star-half');
        else
            $(el).addClass('star-free');
    });
}

App.initNavigation = function() {
    this.menuButtonize($("#account-menu-block"));
    // document.getElementById("mobile-site-selector").addEventListener("change", function() {
    //     document.location.href = this.value;
    // })
}

App.menuButtonize = function(elem) {
    elem.find(".dropdown-btn").on("click", function(e){
        e.preventDefault();
        elem.toggleClass("open");
    });
    $(document).on("click", function(e){
        if (!$(e.target).closest(elem).length) {
            elem.removeClass("open");
        }
    });
}

/**
 * Helper to determine whether an element is visible (in the viewport)
 */
function isElementInViewport (el) {
    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
}

App.trackingProductsNow = false;
App.impressedProducts = {};
App.initProductAnalytics = function() {
    var that = this;

    // impressions
    $(window).on('DOMContentLoaded load resize scroll', function(){
        that.trackProductImpressions();
    });

    // clicks
    $(".mainBlocks").on("click", ".tile a.to-details", function(e){
        var tile = $(this).parents(".tile").first();
        var item = {
            id: tile.data("itemId"),
            name: tile.data("itemName"),
            price: tile.data("itemPrice"),
            category: tile.data("itemCategory"),
        }

        that.callbacks.modelClicked(item, tile.data("itemList"));
        //e.preventDefault();
    });
}

App.trackProductImpressions = function() {
    if (this.trackingProductsNow) {
        return false;
    }

    this.trackingProductsNow = true;

    var set = [];
    var that = this;

    $(".tile").each(function(idx){
        var id = $(this).data("itemId");
        if (that.impressedProducts[id]) {
            return;
        }

        if (isElementInViewport(this)) {
            set.push({
                id: $(this).data("itemId"),
                name: $(this).data("itemName"),
                price: $(this).data("itemPrice"),
                category: $(this).data("itemCategory"),
                list: $(this).data("itemList"),
                position: idx+1,
            });
        }
    });

    this.trackingProductsNow = false;
    for (var i=0; i<set.length; i++) {
        this.impressedProducts[set[i].id] = set[i];
    }

    if (set.length) {
        try {
            App.callbacks.modelsViewed(set);
        } catch (e) {

        };
    }
}

/**
 * wrapper for multi previews initialization. Decides whether to actually init or not.
 */
App.maybeInitPreviews = function() {
    var self = this;
    var mouseMoveInit = function(){
        window.setTimeout(function(){
            self.shouldInitPreviews = true;
            self.initPreviews();
        }, 500);
        window.document.removeEventListener("mousemove", mouseMoveInit);
    };

    window.document.addEventListener("mousemove", mouseMoveInit);
}

/**
 * Bigger previews that appear in a tooltip upon hovering on small previews
 */
App.initPreviews = function() {
    if (!this.shouldInitPreviews) {
        return false;
    }

    var changePreview = function(step, origin, tooltipCont) {
        // if the origin (tile) does not yet have the images, fetch them
        if (!origin.dataset.images) {
            $.get(
                App.baseUrl + '/item/images',
                {
                    id: origin.dataset.itemId
                },
                function(resp) {
                    if (resp.status == "success") {
                        origin.dataset.images = JSON.stringify(resp.data);
                        changePreview(step, origin, tooltipCont)
                    } else {

                    }
                },
                "json"
            )
        } else {
            var idx = origin.dataset.previewIndex ? parseInt(origin.dataset.previewIndex) : 0;
            idx += step;

            var images = JSON.parse(origin.dataset.images);
            //console.log(idx)

            if (idx>=images.length) {
                idx = images.length-1;
            }

            if (idx >= images.length-1) {
                $(tooltipCont).find(".controls button.next").prop("disabled", true);
            } else {
                $(tooltipCont).find(".controls button.next").prop("disabled", false);
            }
            if (idx <= 0) {
                $(tooltipCont).find(".controls button.prev").prop("disabled", true);
            } else {
                $(tooltipCont).find(".controls button.prev").prop("disabled", false);
            }

            $(tooltipCont).find(".tooltip-content img.image").attr("src", images[idx]);
            origin.dataset.previewIndex = idx.toString();
        }

        $(tooltipCont).find(".tooltip-content .spinner-container").show();
    }

    $(".mainBlocks .tile:not(.tooltipstered)").tooltipster({
        interactive: true,
        delay: [1000, 150],
        //side: ['right', 'left', 'top', 'bottom'],
        functionReady: function(instance, helper){
            var img = $(helper.tooltip).find(".tooltip-content img.image");

            $(helper.tooltip).find(".tooltip-content img.image").on("load", function(e){
                $(helper.tooltip).find(".tooltip-content .spinner-container").hide();
            }).on("error", function(e) {
                img.attr("src", FAILED_IMAGE_URL);
            });

            if (typeof img.attr("src") == "undefined" || img.attr("src") === "") {
                img.attr("src", img.data("src"));
            }

            $(helper.tooltip).find(".controls button.prev").off("click").click(function(){
                changePreview(-1, helper.origin, helper.tooltip);
            });
            $(helper.tooltip).find(".controls button.next").off("click").click(function(){
                changePreview(+1, helper.origin, helper.tooltip);
            });
        },
        theme: 'tooltipster-shadow'
    });
}

window.getServerErrorContainer = function(xhr) {
    let errorContainer = null;

    if (xhr.responseJSON) {
        let json = xhr.responseJSON;
        if (json.errors && Object.values(json.errors).length) {
            errorContainer = json.errors;
        }
    }

    return errorContainer;
}

window.getServerErrorString = function(xhr, preferPrecise) {
    let text = 'An error occurred. I could not find out any other details :(';

    if (xhr.responseJSON) {
        let json = xhr.responseJSON;
        text = (json.message && !preferPrecise) ? json.message : Object.values(json.errors)[0][0];
    } else {
        text = xhr.responseText
    }

    return text;
}


$(document).ready(function(){
    App.init();
});
const customSelect = document.getElementById('mobile-site-selector');
if (customSelect) {
    const selectedOption = customSelect.querySelector('.selected-option');
    const options = customSelect.querySelector('.options');
    selectedOption.addEventListener('click', () => {
        options.classList.toggle('show');
        selectedOption.classList.toggle('show');
    });
    options.addEventListener('click', (e) => {
        if (e.target.classList.contains('option')) {
            selectedOption.classList.remove('show');
            const value = e.target.getAttribute('data-value');
            selectedOption.textContent = e.target.textContent;
            options.classList.remove('show');
        }
    });
    document.addEventListener('click', (e) => {
        if (!customSelect.contains(e.target)) {
            options.classList.remove('show');
            selectedOption.classList.remove('show');
        }
    });
}
